import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ServiceJob = {
	name: NAME,
	apiProvider,
	router,	
};
